import { getISOString } from '@surveycake/utils';
import { ExceptionStatus } from 'app/core/status';
import { SurveyConfig } from 'app/core/survey-config';
import errorImage from 'images/status/error.png';
import notfoundImage from 'images/status/notfound.png';
import offImage from 'images/status/off.png';
import overloadedImage from 'images/status/overloaded.png';

interface Config {
  [n: number]: (
    surveyConfig: SurveyConfig
  ) => {
    image: string;
    title: string;
    info?: string;
  };
}
export const config: Config = {
  [ExceptionStatus.NOT_FOUND]: surveyConfig => ({
    image: notfoundImage,
    title: surveyConfig.wording.common.exception.not_found
  }),
  [ExceptionStatus.NOT_PUBLIC]: surveyConfig => ({
    image: offImage,
    title: surveyConfig.data && surveyConfig.data.not_public_text ? surveyConfig.data.not_public_text : surveyConfig.wording.common.exception.not_public
  }),
  [ExceptionStatus.FULLED]: surveyConfig => ({
    image: overloadedImage,
    title: surveyConfig.data && surveyConfig.data.fulled_text ? surveyConfig.data.fulled_text : surveyConfig.wording.common.exception.fulled
  }),
  [ExceptionStatus.INVALID_DURATION]: surveyConfig => {
    let { starttime, endtime } = surveyConfig.data;
    starttime = starttime
      ? getISOString(new Date(`${starttime.replace(' ', 'T')}Z`))
      : '';
    endtime = endtime
      ? getISOString(new Date(`${endtime.replace(' ', 'T')}Z`))
      : '';

    return {
      image: offImage,
      title:  surveyConfig.data && surveyConfig.data.invalid_duration_text ? surveyConfig.data.invalid_duration_text : surveyConfig.wording.common.exception.invalid_duration,
      info: `${starttime} ～ ${endtime}`
    };
  },
  [ExceptionStatus.MISSING_DEFAULT_ANSWER]: surveyConfig => ({
    image: errorImage,
    title: surveyConfig.wording.common.exception.missing_default_answer.title,
    info: surveyConfig.wording.common.exception.missing_default_answer.content
  }),
  [ExceptionStatus.INVALID_DEFAULT_ANSWER]: surveyConfig => ({
    image: errorImage,
    title: surveyConfig.wording.common.exception.invalid_default_answer.title,
    info: surveyConfig.wording.common.exception.invalid_default_answer.content
  }),
  [ExceptionStatus.MASTER_SURVEY_IS_NOT_EXISTED]: surveyConfig => ({
    image: offImage,
    title: surveyConfig.wording.common.exception.master_survey_is_not_existed
  }),
  [ExceptionStatus.MASTER_SURVEY_IS_OFF]: surveyConfig => ({
    image: offImage,
    title: surveyConfig.wording.common.exception.master_survey_is_off
  }),
  [ExceptionStatus.INVALID_SUBMIT_DURATION]: surveyConfig => ({
    image: errorImage,
    title: surveyConfig.wording.common.exception.invalid_submit_duration.title,
    info: surveyConfig.wording.common.exception.invalid_submit_duration.content
  }),
  [ExceptionStatus.INVALID_ANSWER_OBJECT]: surveyConfig => ({
    image: errorImage,
    title: surveyConfig.wording.common.exception.invalid_answer_object.title,
    info: surveyConfig.wording.common.exception.invalid_answer_object.content
  }),
  [ExceptionStatus.INVALID_TEMPORARY_SURVEY]: surveyConfig => ({
    image: errorImage,
    title: surveyConfig.wording.common.exception.invalid_temporary_survey.title,
    info: surveyConfig.wording.common.exception.invalid_temporary_survey.content
  }),
  /**
   * @todo invalid pro survey
   */
  [ExceptionStatus.INVALID_PRO_SURVEY]: () => ({
    image: offImage,
    title: '',
    info: ''
  }),
  [ExceptionStatus.NOT_ALLOWED]: surveyConfig => ({
    image: errorImage,
    title: surveyConfig.wording.common.exception.not_allowed
  })
};
